import { shallow } from 'zustand/shallow'
import { Route, Routes } from 'react-router-dom'
import ReactGA from 'react-ga'
import { ToastContainer } from 'react-toastify'
import * as DappUI from '@multiversx/sdk-dapp/UI'
import { DappProvider } from '@multiversx/sdk-dapp/wrappers'
import '@metamask/sdk'
import 'react-toastify/dist/ReactToastify.css'

import LoggedIn from './ui/templates/LoggedIn'
import { AuthCheck } from 'src/components'
import AdapterProvider from './BlockchainAdapter/AdapterProvider'
import useTokenRefresh from './hooks/useTokenRefresh'
import { useChainAndNetwork } from 'src/store/chainAndNetwork'
import routes from './routes'
import Page404 from './pages/404'
import 'react-toastify/dist/ReactToastify.css'

const App = () => {
  ReactGA.initialize('UA-147261139-1')
  ReactGA.pageview(window.location.pathname + window.location.search)
  const { chain, network } = useChainAndNetwork(
    (state) => ({
      chain: state.chain,
      network: state.network,
    }),
    shallow,
  )

  type mvxNetworksType = {
    testnet: string
    mainnet: string
  }

  const mvxNetworks: mvxNetworksType = {
    testnet: 'devnet',
    mainnet: 'mainnet',
  }

  const { TransactionsToastList, SignTransactionsModals, NotificationModal } = DappUI
  useTokenRefresh()

  return (
    <AdapterProvider chain={chain}>
      <DappProvider
        key={mvxNetworks[network as keyof mvxNetworksType]}
        environment={mvxNetworks[network as keyof mvxNetworksType]}
        customNetworkConfig={{
          name: 'customConfig',
          apiTimeout: 6000,
          walletConnectV2ProjectId: process.env.REACT_APP_MVX_WALLETCONNECTV2PROJECTID,
        }}>
        <div className=" bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-electric-blue to-black">
          <TransactionsToastList className="custom-toast" successfulToastLifetime={2000} />
          <NotificationModal />
          <SignTransactionsModals className="custom-class-for-modals" />
          <Routes>
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  route.authenticatedRoute ? (
                    <route.component />
                  ) : (
                    <AuthCheck>
                      <LoggedIn>
                        <route.component />
                      </LoggedIn>
                    </AuthCheck>
                  )
                }
              />
            ))}
            <Route
              path="*"
              key="differentKey"
              element={
                <AuthCheck>
                  <LoggedIn>
                    <Page404 />
                  </LoggedIn>
                </AuthCheck>
              }
            />
          </Routes>
          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </DappProvider>
    </AdapterProvider>
  )
}

export default App
